import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { GRAY, VARIANT } from "../../../../constants/colors";
import { goToVendaDigitadaList } from "../../../../routes/coordinator";
import VendasDigitadasApi from "../../../../services/vendasDigitadasApi";
import { useRecoilState } from "recoil";
import { customColors } from "../../../../atoms/customColors";

export default function ModalSendEmailRequest({
  isOpen,
  setIsOpen,
  token,
  permitirPix,
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();

  const colors = useRecoilState(customColors)[0];

  const onClose = () => {
    setIsOpen(false);
    goToVendaDigitadaList(navigate);
  };

  const [loading, setLoading] = useState(false);

  async function sendEmail() {
    try {
      setLoading(true);
      const response = await VendasDigitadasApi.senEmailWithLinkForPayment(
        token
      );
      setLoading(false);
      toast.success("Link enviado para o e-mail com sucesso!");
      goToVendaDigitadaList(navigate);
    } catch (error) {
      console.log("error: ", error);
      toast.error("Não foi possível enviar o e-mail de pagamento!");
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Venda criada com sucesso!</Text>
            </Flex>
          </ModalHeader>
          <ModalBody display={"flex"} justifyContent={"center"}>
            {permitirPix && (
              <Text>
                Deseja enviar um e-mail com o link de pagamento para o cliente?
              </Text>
            )}
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={GRAY} color={"white"} mr={3} onClick={onClose}>
              Fechar
            </Button>
            {permitirPix && (
              <Button
                background={VARIANT}
                color={"white"}
                mr={3}
                disabled={loading}
                onClick={() => {
                  sendEmail();
                  onClose();
                }}
              >
                {loading ? <Spinner /> : `Enviar E-mail`}
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
